import { isFeatureEnabled } from 'owa-feature-flags';
import Item from 'owa-service/lib/contract/Item';
import ExtendedPropertyType from 'owa-service/lib/contract/ExtendedPropertyType';

const EXPLICIT_MESSAGE_CARD_PROPERTY_NAME = 'ExplicitMessageCard';

export function getExtendedPropertyFromItem(
    item: Item,
    propertyName: string
): ExtendedPropertyType {
    if (item) {
        const extendedProperties = item.ExtendedProperty;
        if (extendedProperties) {
            const numProperties = extendedProperties.length;
            for (let i = 0; i < numProperties; i++) {
                const prop = extendedProperties[i];
                if (prop.ExtendedFieldURI.PropertyName === propertyName) {
                    return prop;
                }
            }
        }
    }

    return null;
}

export default function doesItemContainCardData(item: Item): boolean {
    if (!isFeatureEnabled('rp-actionableMessages')) {
        return false;
    }

    const prop = getExtendedPropertyFromItem(item, EXPLICIT_MESSAGE_CARD_PROPERTY_NAME);
    if (prop?.Value && (<string>prop.Value).toLowerCase() === 'true') {
        return true;
    } else {
        return false;
    }
}
